// extracted by mini-css-extract-plugin
export default {"program":"program__sHAjt","col":"col__iMv76","badge":"badge__5orJZ","badgeRow":"badgeRow__HRBeH","tooltipText":"tooltipText__mIQAP"};